"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var DetailsTabRow;
(function (DetailsTabRow) {
  DetailsTabRow["Range"] = "range";
  DetailsTabRow["String"] = "string";
  DetailsTabRow["Date"] = "date";
  DetailsTabRow["Wysiwyg"] = "wysiwyg";
  DetailsTabRow["Number"] = "number";
  DetailsTabRow["Boolean"] = "boolean";
  DetailsTabRow["List"] = "list";
  DetailsTabRow["Dictionary"] = "dictionary";
  DetailsTabRow["Template"] = "template";
  DetailsTabRow["TemplateWysiwyg"] = "templateWysiwyg";
  DetailsTabRow["Document"] = "document";
  DetailsTabRow["Accordion"] = "accordion";
})(DetailsTabRow || (DetailsTabRow = {}));
var _default = DetailsTabRow;
exports.default = _default;